/** Avoid running the same function twice within the specified timeframe. */
export const debounce = (
    func: () => void,
    wait: number,
    immediate: boolean = false
) => {
    let timeout: NodeJS.Timeout;
    /* eslint-disable @typescript-eslint/no-explicit-any */
    return function (...args: any[]) {
        /* eslint-disable @typescript-eslint/no-this-alias */
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        }, wait);
        if (immediate && !timeout) {
            func.apply(context, args);
        }
    };
};
